// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginPage_wrapper__FLkHA"};